import { PreferenceUtilisateurApi } from '@/api/preference-utilisateur';
import { PreferencesUtilisateur } from '@/model/preferences-utilisateur/preferences-utilisateur';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('preferenceUtilisateur');

builder.addStatePart('preferenceUtilisateur', null,
  (utilisateur: string) => PreferenceUtilisateurApi.getPreferenceUtilisateur(utilisateur).catch(() => new PreferencesUtilisateur()),
  'SESSION', 1800);
builder.setActions({
  savePreferenceUtilisateur ({ dispatch, commit }: any, { utilisateur, preferenceUtilisateur }: { utilisateur: string, preferenceUtilisateur: PreferencesUtilisateur }) {
    return PreferenceUtilisateurApi.savePreferenceUtilisateur(utilisateur, preferenceUtilisateur).then(() => {
      commit('CLEAR_CACHE');
      return dispatch('loadPreferenceUtilisateur', utilisateur);
    });
  }
});
export default builder.build();
